import {
  Box,
  Button,
  Collapse,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import Clear from '@mui/icons-material/Clear';
import { useState } from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';

// @TODO: ** This component is not complete it requires the Filters from [microsites-ui] **
// import Filters from "../Filters";

import {
  ButtonsContainer,
  FilterButton,
  SearchContainer,
} from './SearchControls.styles';
import { proAccountThemeCoreUI } from '@orcha/micro-library-core-ui';

export type SearchControlsProps = {
  handleSearch: (searchTerm?: string) => void;
  translatedText: {
    placeholder: string;
    searchInputLabel: string;
    clearSearchLabel: string;
    filterButton: string;
    searchButton: string;
  };
  overrides?: {
    placeholderText?: string;
    buttonText?: string;
  };
  size?: 'small' | 'medium';
  logEventAnalytic: (event: {
    category: string;
    action: string;
    label: string;
  }) => void;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
};

/**
 * SearchControls component from [MicroLibrarySearchUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibrarySearchUI)
 * @TODO: ** This component is not complete it requires the Filters from microsites-ui **
 * @param {SearchControlsProps} props - The props for the SearchControls component
 * @param {["translatedText"]} translatedText - The translated text for the SearchControls component
 * @returns {React.ReactNode} The SearchControls component
 */

export const SearchControls = ({
  handleSearch,
  overrides,
  size,
  logEventAnalytic,
  searchTerm,
  setSearchTerm,
  translatedText,
}: SearchControlsProps) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(true);
  const toggleFilters = () => {
    setIsFiltersOpen(!isFiltersOpen);
  };

  const invokeSearch = () => {
    logEventAnalytic({
      category: 'Search',
      action: 'Searched for an app using the search bar - microsite',
      label: `${searchTerm}`,
    });
    handleSearch(searchTerm);
  };

  return (
    <>
      <SearchContainer>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TextField
            sx={{ backgroundColor: proAccountThemeCoreUI.palette.common.white }}
            size={size}
            fullWidth
            onChange={(event) => {
              setSearchTerm(event.target.value);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                invokeSearch();
              }
            }}
            value={searchTerm ?? ''}
            placeholder={
              overrides?.placeholderText ?? translatedText.placeholder
            }
            inputProps={{
              maxLength: 100,
              'data-testid': 'search-input',
              'aria-label': translatedText.searchInputLabel,
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              sx: {
                fontSize: proAccountThemeCoreUI.typography.fontSize,
                paddingRight: `${proAccountThemeCoreUI.spacing(6)} !important`,
              },
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              right: proAccountThemeCoreUI.spacing(0.5),
              display: searchTerm && searchTerm?.length > 0 ? 'block' : 'none',
            }}
          >
            <IconButton
              aria-label={translatedText.clearSearchLabel}
              onClick={() => setSearchTerm('')}
              sx={{ padding: proAccountThemeCoreUI.spacing(1) }}
              size={size}
            >
              <Clear />
            </IconButton>
          </Box>
        </Box>

        <ButtonsContainer>
          <FilterButton
            data-testid="toggle-filters-button"
            variant="contained"
            endIcon={<FilterListIcon />}
            disableElevation
            className={isFiltersOpen ? 'showFilters' : ''}
            onClick={toggleFilters}
            fullWidth
          >
            {translatedText.filterButton}
          </FilterButton>

          <Button
            color="primary"
            data-testid="search-button"
            variant="contained"
            onClick={invokeSearch}
            fullWidth
            sx={{
              [proAccountThemeCoreUI.breakpoints.up('sm')]: {
                minWidth: '180px',
              },
            }}
          >
            {overrides?.buttonText ?? translatedText.searchButton}
          </Button>
        </ButtonsContainer>
      </SearchContainer>
      <Collapse orientation="vertical" in={isFiltersOpen}>
        <Box mt={1.5}>
          {/* 
        @TODO: ** This component is not complete it requires the Filters from microsites-ui **
        <Filters /> 
        */}
        </Box>
      </Collapse>
    </>
  );
};
